import VendorStockContainer from '@components/containers/vendorStock';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

/** The open-orders ledger on its own — the Stock container pinned to its production view. */
const VendorProductionOrders: FC = () => (
    <VendorLayout>
        <VendorStockContainer fixedView="production" />
    </VendorLayout>
);

export default VendorProductionOrders;
